import { render, staticRenderFns } from "./TabsButtons.vue?vue&type=template&id=1c86368a&scoped=true"
import script from "./TabsButtons.vue?vue&type=script&lang=js"
export * from "./TabsButtons.vue?vue&type=script&lang=js"
import style0 from "./TabsButtons.vue?vue&type=style&index=0&id=1c86368a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c86368a",
  null
  
)

export default component.exports